import { createAction, props } from '@ngrx/store';
import { MonthlyCashFlow } from '../model/accounting.model';


export const getMonthlyCashFlowStateSuccess = createAction(
  '[Accounting] get monthly cash flow state success',
  props<{ monthlyCashFlowState: MonthlyCashFlow[] }>()
);

export const getMonthlyCashFlowStateError = createAction(
  '[Accounting] get monthly cash flow state error',
  props<{ error: string }>()
);